module.exports = __webpack_public_path__ + "static/img/truck.cc9c3fa.svg";